import { useEffect, useRef, useState } from "react";
import { Canvas, PencilBrush, Image as FabricImage } from "fabric";
import { PenTool, RotateCcw } from "lucide-react";

export const SignaturePanel = ({ onSignatureChange, required = false, initialSignature = "" }) => {
  const canvasRef = useRef(null);
  const fabricCanvasRef = useRef(null); // keep persistent reference
  const [isDrawing, setIsDrawing] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    if (!canvasRef.current || fabricCanvasRef.current) return; // initialize only once

    const canvas = new Canvas(canvasRef.current, {
      width: 400,
      height: 150,
      backgroundColor: "#ffffff",
    });

    // Set brush
    canvas.isDrawingMode = isDrawing;
    canvas.freeDrawingBrush = new PencilBrush(canvas);
    canvas.freeDrawingBrush.color = "#000000";
    canvas.freeDrawingBrush.width = 2;

    canvas.on("path:created", () => {
      setIsEmpty(false);
      if (onSignatureChange) {
        onSignatureChange(canvas.toDataURL({ format: "png", quality: 1 }));
      }
    });

    fabricCanvasRef.current = canvas; // store it in ref

    // Load initial signature if provided
    if (initialSignature) {
      loadSignatureFromDataURL(initialSignature);
    }
  }, [onSignatureChange, initialSignature]);

  // Load signature from data URL
  const loadSignatureFromDataURL = (dataURL) => {
    const canvas = fabricCanvasRef.current;
    if (!canvas || !dataURL) return;

    // Clear existing content
    canvas.clear();
    canvas.backgroundColor = "#ffffff";

    // Load image from data URL
    const img = new Image();
    img.onload = () => {
      const fabricImg = new FabricImage(img, {
        left: 0,
        top: 0,
        scaleX: canvas.width / img.width,
        scaleY: canvas.height / img.height,
      });
      canvas.add(fabricImg);
      canvas.renderAll();
      setIsEmpty(false);
    };
    img.src = dataURL;
  };

  const handleClear = () => {
    const canvas = fabricCanvasRef.current;
    if (!canvas) return;
    canvas.clear();
    canvas.backgroundColor = "#ffffff"; // restore background
    canvas.renderAll();
    setIsEmpty(true);
    if (onSignatureChange) onSignatureChange("");
  };

  const toggleDrawMode = () => {
    const canvas = fabricCanvasRef.current;
    if (!canvas) return;
    const newDrawMode = !isDrawing;
    setIsDrawing(newDrawMode);
    canvas.isDrawingMode = newDrawMode;
  };

  return (
    <div className="signature-panel">
      <label>Employee's Signature{required && "*"}</label>
      <div className="signature-container">
        <div className="signature-buttons">
          <button
            type="button"
            onClick={toggleDrawMode}
            style={{
              backgroundColor: isDrawing ? "#4CAF50" : "#fde2e2ff", // green if drawing, gray if not
              color: isDrawing ? "#fff" : "#000",
            }}
          >
            <PenTool color={isDrawing ? "#fff" : "#000"} /> {isDrawing ? "Drawing On" : "\u00A0\u00A0\u00A0 \u00A0Draw\u00A0\u00A0 \u00A0  \u00A0 "}
          </button>
          <button type="button" onClick={handleClear}>
            <RotateCcw /> Clear
          </button>
        </div>
        <canvas
          ref={canvasRef}
          style={{ touchAction: "none", border: "1px solid #ccc" }}
        />
        <p>{isEmpty ? "Please draw your signature above" : "Signature captured"}</p>
      </div>
    </div>
  );
};
